<template>
  <div class="doc-page">
    <div class="doc-page-middle">
      <div class="doc-page-iframe">
        <iframe v-if="url && sid" ref="iframe" :src="url" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Bus from "./bus";
import { getDocConfig, getDocEvents, getHideBtn, SearchParams } from "./utils";
import Role from "@/mixins/role";

export default {
  name: "DocMain",
  mixins: [Role],
  props: {
    type: Number,
    current: Object,
    step: Object
  },
  data() {
    return {
      url: undefined,
      events: getDocEvents(this, this.type),
    };
  },
  computed: {
    ...mapGetters(["rtcClient", "shareType", "sid", "leftToolType"]),
    location() {
      return this.rtcClient?.RTMSession?.ccServerUrl;
    },
    docUrl() {
      return this.location?.find((val) => val.type == 12);
    },
    updateUrl() {
      return [this.sid, this.current];
    },
    hostPreview() {
      return this.current?.hostPreview;
    },
    needSetUi() {
      return [this.share, this.hostPreview, this.current?.shareId];
    },
    isNotDisturb() {
      return this.$store.state.defaultInfo.isNotDisturb === 'false'
    }
  },
  watch: {
    updateUrl: {
      immediate: true,
      handler() {
        this.sid && this.init();
      },
    },
    needSetUi() {
      this.setUi();
    },
    shareType(n, o) {
      if (n == 4 || o == 4) {
        this.setUi();
      }
    },
    leftToolType() {
      setTimeout(() => {
        this.setMessage("updateSize")
      }, 50)
    },
    share(n) {
      if (n) {
        this.setMessage("updateVisibilityToolbar")
      }
      this.logger.info({
        code: 2011, message: {
          url: this.url,
          share: n
        }
      })
    }
  },
  mounted() {
    window.addEventListener("message", this.getMessage, false);

    Object.keys(this.events).map((key) => {
      Bus.$on(key, this.events[key]);
    });
  },
  beforeDestroy() {
    window.removeEventListener("message", this.getMessage, false);
    Object.keys(this.events).map((key) => {
      Bus.$off(key, this.events[key]);
    });
  },
  methods: {
    init() {
      this.$emit(
        "message",
        {
          event: "update:doc",
          data: null,
        },
        this.type
      );
      this.$emit(
        "message",
        {
          event: "update:page",
          data: 1,
        },
        this.type
      );
      this.$emit(
        "message",
        {
          event: "update:scale",
          data: 1,
        },
        this.type
      );
      const { viewUrl, uid, userName, roomId } = this.current;
      const query = {
        url: viewUrl,
        shareName: userName,
        uid: uid,
        type: this.type === 0 ? "all" : "whiteboard",
        lang: this.$i18n.locale,
        sid: this.sid,
        roomId: roomId,
        device: "0",
        role: "1",
        key: this.type,
        t: Date.now(),
      };
      // this.url = "http://localhost:4000/file/web/doc?" + SearchParams(query) + "&mode=html-first";
      this.url = this.docUrl.addr + "/file/web/doc?" + SearchParams(query) + "&mode=html-first";
    },
    getMessage(e) {
      if (typeof e.data !== "object") return;
      switch (e.data.event) {
        case "created":
          var config = getDocConfig(this.type === 0, this.share);
          this.setMessage(
            "init",
            Object.assign({}, config, {
              local: !this.share,
              hostPreview: this.current?.hostPreview,
              turnPageResetScale: this.type != 0
            })
          );
          break;
        case "ready":
          this.setMessage("updateVisibilityToolbar")
          this.$emit("message", e.data, this.type);
          break
        case "update:page":
        case "update:scale":
        case "update:doc":
        case "update:step":
          this.$emit("message", e.data, this.type);
          break;
        case "showDocPage":
          this.$emit("showList");
          break;
      }
    },
    setMessage(event, data) {
      return this.$refs.iframe?.contentWindow?.postMessage(
        { event, data },
        "*"
      );
    },
    async setUi() {
      console.log("setUi........");
      let has = true;
      if (this.shareType === 4) {
        has = false;
      } else {
        has = this.share === 1;
      }
      if (this.share) {
        if (this.current.shareId) {
          this.setMessage("setShareId", this.current.shareId);
        }
        this.setMessage("hostPreview", false);
      }
      this.setMessage("setLocal", !has);
      this.setMessage("hideBrush");
      this.setMessage("setHideBtn", getHideBtn(this.type === 0, has));
      this.setMessage("setHideBtn", {
        page: this.shareType === 4,
      });
      console.log(this.step, "this.step");

    }
  },
};
</script>

<style scoped>
.doc-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.doc-page-middle {
  flex: 1;
}

.doc-page-iframe {
  position: relative;
  height: 100%;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
}

.toolbar {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 522px;
  height: 44px;
  background: #1c1e38;
  box-shadow: 0px 0px 6px 0px rgba(51, 51, 51, 0.2);
  border-radius: 8px;
  opacity: 0.96;
  border: 1px solid rgba(104, 118, 180, 0.3);
}
</style>
